import { DynamicContentType } from '../../types/content.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type Bullet = {
  text: string
  icon: LucideIconName
}

export type BulletsData = {
  marginBottom?: string
  marginTop?: string
  bullets: Bullet[]
}

const defaultBullet: Bullet = {
  text: 'Lorem ipsum dolor sit amet',
  icon: LucideIconName.Lightbulb,
}

export const bullets: DynamicContentType<BulletsData> = {
  name: 'bullets',
  viewName: 'Bulletpoints',
  featureKey: 'bullets',
  icon: LucideIconName.List,
  uuid: '',
  data: {
    bullets: [defaultBullet, defaultBullet],
  },
}
